import React from 'react';

// Privacy Policy Page Component
const PrivacyPolicyPage: React.FC = () => {
  return (
    <main className="bg-white py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-white shadow-lg rounded-lg p-8">
          <h1 className="text-4xl font-bold text-center mb-8 text-indigo-900">Privacy Policy</h1>

          <div className="prose max-w-none text-gray-800">
            <p>
              Your privacy is important to us. It is the Campaign's policy to respect your privacy regarding any information we may collect from you across our website, and other sites we own and operate.
            </p>

            <h2 className="text-2xl font-bold mb-4 text-indigo-900 mt-8">Information We Collect</h2>

            <p>
              We only ask for personal information when we truly need it to provide a service to you. We collect it by fair and lawful means, with your knowledge and consent. We also let you know why we’re collecting it and how it will be used.
            </p>

            <p>
              We only retain collected information for as long as necessary to provide you with your requested service. What data we store, we’ll protect within commercially acceptable means to prevent loss and theft, as well as unauthorized access, disclosure, copying, use, or modification.
            </p>

            <h2 className="text-2xl font-bold mb-4 text-indigo-900 mt-8">Third-Party Services</h2>

            <p>
              Our website may link to external sites that are not operated by us. Please be aware that we have no control over the content and practices of these sites and cannot accept responsibility or liability for their respective privacy policies.
            </p>

            <p>
              We may use third-party services, such as Anedot, for donation processing. These services have their own privacy policies, and we encourage you to review them.
            </p>

            <h2 className="text-2xl font-bold mb-4 text-indigo-900 mt-8">Your Rights</h2>
              
              <p>
                You are free to refuse our request for your personal information, with the understanding that we may be unable to provide you with some of your desired services.
              </p>
              
              <p>
                Your continued use of our website will be regarded as acceptance of our practices around privacy and personal information. If you have any questions about how we handle user data and personal information, feel free to contact us.
              </p>
              
              <p className="mt-12 text-gray-600 text-center">
                <strong>This policy is effective as of March 14, 2025.</strong>
              </p>
            </div>
          </div>
        </div>
      </main>
      );
    }
    
    export default PrivacyPolicyPage;